import { Typography, styled } from '@ori-ui/mui';

export const AppInfoRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
}));

export const AppIcon = styled('img')({
  height: 60,
  width: 60,
});

export const AppNameAndDescription = styled('div')({
  alignItems: 'flex-start',
  alignSelf: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
});

export const AppName = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  display: '-webkit-box',
  fontSize: theme.typography.pxToRem(13),
  fontWeight: theme.typography.fontWeightBold,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
}));

export const AppDescription = styled(Typography)({
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
});
